import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { MdSchedule, MdEdit } from 'react-icons/lib/md';
import { FaFileExcelO } from 'react-icons/lib/fa';
import { fetchSchedule } from '../../actions/project_actions';
import { withAuth } from '../../actions/';
import ScheduleForm from './schedule_form';
import ScheduleHistory from './ScheduleHistory';
import ReadonlySchedule from './schedule_readonly';
import { getMILESTONES } from './schedule_constants';

class ProjectSchedule extends Component {
  // static PropTypes = {
  //   fetch: PropTypes.bool,
  //   projectId: PropTypes.string.isRequired,
  //   permissions: PropTypes.object.isRequired,
  //   divisionName: PropTypes.string.isRequired,
  //   schedule: PropTypes.object.isRequired,
  //   fetchSchedule: PropTypes.func.isRequired,
  //   saveSchedule: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);
    this.state = {
      isEditable: false,
      isLoading: false,
      showHistory: false,
      showExcel: false,
    }

    this.patchToServer = this.patchToServer.bind(this);
    this.toggleEditable = this.toggleEditable.bind(this);
    this.toggleHistory = this.toggleHistory.bind(this);
    this.handleExportToExcel = this.handleExportToExcel.bind(this);
  }

  UNSAFE_componentWillMount () {
    if (this.props.fetch) this.props.fetchSchedule(this.props.projectId);
  }

  toggleEditable () {
    this.setState({
      isEditable: !this.state.isEditable,
      showHistory: false,
      showExcel : !this.state.showExcel,
    });
  }

  patchToServer (objects, callback) {
    const { projectId } = this.props;
    const url = `/projects/${projectId}/schedule`;
    const data = objects.map(obj => ({...obj, projectId}));
    return withAuth(
      {method: 'patch', url: url, data},
      resp => {
        this.props.saveSchedule(resp.data)
        if (callback) callback(resp.data);
      }
    )
  }

  toggleHistory () {
    this.setState({ showHistory: !this.state.showHistory });
  }

  handleExportToExcel(schedule) {  

    let url = 'projects/ExportSchedule';
    let method = 'post';
    let responseType = 'arraybuffer';

    withAuth(
        { method, url, responseType, data: schedule },
        (response) => {
             var data = response.data;
             var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
             var blob = new Blob([data], { type: contentType });
             var downloadUrl = window.URL.createObjectURL(blob);
             var link = document.createElement('a');
             link.href = downloadUrl;
             link.download = 'ProjectSchedule.xlsx';
             link.click();
        },
        this.errorHandler
    )
}

  render () {
    const { projectId, divisionName, permissions, isScheduleEditDisabled } = this.props;
    const { isEditable, isLoading, showHistory, showExcel } = this.state;
    const className = 'row-wide project-schedule' + (isEditable ? ' editable' : '');
    const showButtons = isEditable && !isLoading;
    const { roleModules } = permissions.editPrivileges;

    const canEdit = roleModules !== null && roleModules.includes('Schedule') 
    ? true : false;

    const MILESTONES = getMILESTONES(divisionName);
    const schedule = _.pick(this.props.schedule, MILESTONES);
    const scheduleStage = this.props.schedule.stage;

    return (
      <div id="schedule" className={className}>
        <div className="col s12">

          {!showExcel &&
            <button className="btn-save btn-excel float-right margin-top-035" onClick={() => this.handleExportToExcel(schedule)}>
              <span className="margin-right-05"> <FaFileExcelO size={12} color='#008000' /></span>
              Excel</button>}

          <h4 className="bar-bottom">
            <span><MdSchedule size={20} /></span> Schedule

            {isScheduleEditDisabled && <span className="schedule-notif">Source: P6</span>}

            { canEdit && !isScheduleEditDisabled
              ? <span className = 'fa-Icon-Edit' onClick={this.toggleEditable}><MdEdit size={22} color='#8492a6'/></span>
              : null }
            <button className="btn-section" onClick={this.toggleHistory}>
              { showHistory ? 'Close History' : 'History' }
            </button>
          </h4>
        </div>

        { showHistory
          ? <ScheduleHistory
              projectId={projectId}
            />
          : null
        }


        { showButtons
          ? <ScheduleForm
              projectId={projectId}
              schedule={schedule}
              scheduleStage={scheduleStage}
              divisionName={divisionName}
              onCancel={this.toggleEditable}
              save={this.patchToServer}
              showMasterEdit={permissions.showMasterEdit}
            />
          : <ReadonlySchedule
              schedule={schedule}
              divisionName={divisionName}
            />
        }

        { isLoading ? <div className="loader"/> :null }
      </div>
    );
  }
}


function saveSchedule (schedule) {
  return dispatch => {
    dispatch({
      type: 'SET_CURRENT_SCHEDULE',
      data: schedule
    })
  }
}

ProjectSchedule.propTypes = {
  fetch: PropTypes.bool,
  projectId: PropTypes.string.isRequired,
  permissions: PropTypes.object.isRequired,
  divisionName: PropTypes.string.isRequired,
  schedule: PropTypes.object.isRequired,
  fetchSchedule: PropTypes.func.isRequired,
  saveSchedule: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
  return {
    projectId: ownProps.projectId,
    schedule: state.projectsStore.schedule,
    divisionName: state.projectsStore.divisionName,
    isScheduleEditDisabled: state.projectsStore.isScheduleEditDisabled,
    p6UpdatedDate: state.projectsStore.p6UpdatedDate
  };
}

export default connect(mapStateToProps, {fetchSchedule, saveSchedule})(ProjectSchedule);